// 屏蔽element-plus select 销毁后的getComputedStyle报错
const originGetComputedStyle = window.getComputedStyle
window.getComputedStyle = function(el, pseudo) {
	if(!el || !(el instanceof Element)){
		return {}
	}
	return originGetComputedStyle.call(this, el, pseudo)
}
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $ from 'jquery'
import './utils/fixElementPlus.js'
import ElementPlus, {ElLoading} from 'element-plus'
import 'element-plus/dist/index.css'
import * as ELementPlusIconsVue from '@element-plus/icons-vue'                  //引入Element-icons需npm 安装
import zhCn from 'element-plus/es/locale/lang/zh-cn'        //引入中文包
import print from 'vue3-print-nb'


const app = createApp(App)
app.use(router)
app.use(store)
app.use(print)
app.use(
	ElementPlus,
	{
		locale: zhCn,		//汉化element-plus组件
	}
)

//===全局注册ElementPlusIcons
for (const [name, component] of Object.entries(ELementPlusIconsVue)){
	app.component(name, component);
}
//END 全局注册ElementPlusIcons
app.mount('#app')

//全局变量

// app.config.globalProperties.$baseUrl = "https://www.luckydog.design/pet/php/"
app.config.globalProperties.$baseUrl = "http://ahis.ytstx.com/php/"
app.config.globalProperties.$ossUrl = "https://www.luckydog.design/pet/php/"

let loadingInstance = null
app.config.globalProperties.$showLoading = function (loadingText){
	loadingInstance = ElLoading.service({
		lock: true,
		text: loadingText || '加载中',
		fullscreen: true,
		background: 'rgba(0, 0, 0, 0.5)',
	})
}

app.config.globalProperties.$closeLoading = function (){
	if (loadingInstance) {
		loadingInstance.close()
		loadingInstance = null
	}
}

app.config.globalProperties.$goCaseMain = function(tabName, caseId){
	// 获取父组件（Main.vue）的 mainTabs
	let parent = this.$parent
	while (parent && parent.mainTabs === undefined) {
		parent = parent.$parent
	}

	if (parent && parent.mainTabs) {
		// 检查 CaseMain 是否已经打开
		let caseMainTab = parent.mainTabs.find(tab => tab.name === 'CaseMain')

		if (caseMainTab) {
			// 如果已打开，先关闭它
			let tabIndex = parent.mainTabs.findIndex(tab => tab.name === 'CaseMain')
			parent.mainTabs.splice(tabIndex, 1)

			// 如果关闭的是当前激活的tab，需要切换到其他tab
			if (parent.mainTabsActiveName === 'CaseMain') {
				// 切换到最后一个tab或Home
				if (parent.mainTabs.length > 0) {
					let lastTab = parent.mainTabs[parent.mainTabs.length - 1]
					parent.mainTabsActiveName = lastTab.name
					this.$router.push({ name: lastTab.name })
				} else {
					parent.mainTabsActiveName = 'Home'
					this.$router.push({ name: 'Home' })
				}
			}

			// 延迟一下再打开，确保关闭动画完成
			this.$showLoading('正在打开')
			setTimeout(() => {
				this.$router.push({ name: 'CaseMain', query: { tabName: tabName, caseId: caseId } })
				this.$closeLoading()
			}, 50)
		} else {
			// 如果没有打开，直接打开
			this.$showLoading('正在打开')
			this.$router.push({ name: 'CaseMain', query: { tabName: tabName, caseId: caseId } })
			this.$closeLoading()
		}
	} else {
		// 如果找不到父组件，直接导航
		this.$showLoading('正在打开')
		this.$router.push({ name: 'CaseMain', query: { tabName: tabName, caseId: caseId } })
		this.$closeLoading()
	}
}

//===BEGIN 全局ajax请求方法 BY PHP======
app.config.globalProperties.$request = function (phpFile,paraData,func,that){
	$.ajax({
		url: that.$baseUrl+phpFile,
		type: 'POST',
		dataType: 'json',
		xhrFields: {
			withCredentials: true
		},
		headers: {
			"token": localStorage.getItem('token'),
			"tenant": "wf"
		},
		async: true,
		data: paraData,
		success: function(res) {
			that.$closeLoading()
			if (res.code === 200){
				func(res)
			} else if(res.code === 401){
				localStorage.clear();
				that.$message.error('登录过期，即将返回')
				setTimeout(() => {
					that.$router.push({ name: 'Login' })
				}, 1500);
			}
			else {
				that.$message.error(res.msg)
			}
		},
		fail: function(res){
			that.loading =  false
			that.$closeLoading()
			that.$message.error('请求失败')
		},
		error: function(rese) {
			that.loading = false
			that.$closeLoading()
			that.$message.error(rese.responseText)
			console.log(rese)
		}
	})
}
//===END 全局ajax请求方法 BY PHP===

app.config.globalProperties.$toDate = function (number){
	let n = number * 1000;
	let date = new Date(n);
	let Y = date.getFullYear() + '-';
	let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	return (Y + M + D)
}

app.config.globalProperties.$getDoctor = function(that){
	that.$request('sys/doctorList.php',{},function(res){
		that.arrDoctor = res.data
	},that)
}

app.config.globalProperties.$calcAge = function(birthdayDate){
	//根据出生年月计算年龄，birthdayDate 格式为yyyy-MM，返回结果为**岁**月
	let now = new Date()
	let age = now.getFullYear() - birthdayDate.substring(0,4)
	let month = now.getMonth() + 1 - birthdayDate.substring(5,7)
	return age+'岁'+month+'月'
}

app.config.globalProperties.$updateCaseBase = function(that, fieldName, fieldValue){		//更新病历基本信息
	if (fieldValue !== that.caseInfo[fieldName]){
		that.$request('case/updateBase.php',{caseId: that.caseId, fieldName: fieldName, fieldValue: fieldValue},function(res){},that)
	}
}

app.config.globalProperties.$previewImage = function(itemImg){
	ElImagePreview({
		images: [itemImg],
	})
}

app.config.globalProperties.$formatDateTime = function(dateStr){
	const date = new Date(dateStr)
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')
	const hours = String(date.getHours()).padStart(2, '0')
	const minutes = String(date.getMinutes()).padStart(2, '0')
	const seconds = String(date.getSeconds()).padStart(2, '0')
	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

//去掉字符串中的字母和斜杠
app.config.globalProperties.$removeAlphaSlash = function(str){
	return str.replace(/[a-zA-Z/]/g, '')
}

//忽略控制台报错
window.addEventListener('error', (event) => {
	// 匹配这个select的resizeObserver报错
	if(event.message.includes('getComputedStyle') && event.filename.includes('useSelect.mjs')){
		event.preventDefault()
		console.warn('element‑plus select内部ResizeObserver异常，已忽略')
	}
})



